"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLPagePager = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const consts_1 = require("@opsbase/lib-data-query/consts");
const findGroupByType_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useDataSearch_1 = __importDefault(require("@opsbase/react-gql-datasearch/useDataSearch"));
const react_markdown_1 = require("@opsbase/react-markdown");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ViewSpinner_1 = __importDefault(require("@opsbase/web-ctrl-view/ViewSpinner"));
const ChevronLeftIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronLeftIcon"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const CollapseMoreIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CollapseMoreIcon"));
const ExpandMoreIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ExpandMoreIcon"));
const WarnIcon_1 = __importDefault(require("@opsbase/web-icons/icons/WarnIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = expanded => ({
    root: {
        borderRadius: '8px 8px 0 0',
        backgroundColor: lib_palette_1.default.positive.light,
        color: 'white',
        padding: 4,
        maxHeight: 24,
    },
    expander: {
        borderRadius: '0 0 8px 8px',
        opacity: 0.8,
        backgroundColor: lib_palette_1.default.positive.light,
        color: 'white',
        maxHeight: 12,
    },
    hiddenbit: {
        backgroundColor: lib_palette_1.default.positive.light,
        color: 'white',
        borderTop: expanded ? '1px solid white' : '',
        padding: expanded ? '8px 16px' : '0 16px',
        maxHeight: expanded ? 200 : 0,
        transition: 'padding-top 0.3s, padding-bottom 0.3s, max-height 0.3s',
    },
});
const DVLPagePager = function () {
    const dt = (0, useDataTree_1.default)();
    return (react_1.default.createElement(ViewSpinner_1.default, { viewId: dt.viewId },
        react_1.default.createElement(DataViewPagerInner, null)));
};
exports.DVLPagePager = DVLPagePager;
exports.default = exports.DVLPagePager;
const DataViewPagerInner = function () {
    const dt = (0, useDataTree_1.default)();
    const { filters, groupBys, reportPage } = (0, useView_1.default)(dt.viewId);
    const { setReportPage } = (0, useViewActions_1.default)(dt.viewId);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses, [expanded]);
    const bigGroupBy = (0, react_1.useMemo)(() => (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.RELATED_MODEL), [groupBys]);
    const associatedFilters = filters.filter(fb => fb.queryFieldKey === (bigGroupBy === null || bigGroupBy === void 0 ? void 0 : bigGroupBy.queryFieldKey));
    const { loading, data } = (0, useDataSearch_1.default)(bigGroupBy === null || bigGroupBy === void 0 ? void 0 : bigGroupBy.queryFieldKey);
    const totalCount = (data === null || data === void 0 ? void 0 : data.totalCount) || 0;
    const numOfPages = Math.ceil(totalCount / consts_1.GroupPageSize);
    const handleClickPrev = (0, react_1.useCallback)(() => {
        setReportPage(reportPage - 1);
    }, [setReportPage, reportPage]);
    const handleClickNext = (0, react_1.useCallback)(() => {
        setReportPage(reportPage + 1);
    }, [setReportPage, reportPage]);
    const handleClickExpand = (0, react_1.useCallback)(() => {
        setExpanded(!expanded);
    }, [expanded]);
    const handleChangePage = (0, react_1.useCallback)(v => {
        if (v < 1)
            v = 1;
        if (v > numOfPages)
            v = numOfPages;
        setReportPage(v - 1);
    }, [numOfPages, setReportPage]);
    return (0, react_1.useMemo)(() => {
        if (!bigGroupBy || loading || !!associatedFilters.length || totalCount < consts_1.GroupPageSize)
            return null;
        const isLoading = dt.dataStatus.loadingItems;
        const hasPrev = reportPage > 0;
        const hasNext = reportPage < numOfPages - 1;
        return (react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, classes: { root: myCss.root } },
                react_1.default.createElement(WarnIcon_1.default, null),
                react_1.default.createElement(Pane_1.default, { grow: true },
                    react_1.default.createElement(Text_1.default, { noWrap: true, withEllipsis: true }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('lmss-pager')))),
                isLoading && (react_1.default.createElement(Pane_1.default, { style: { maxWidth: 160, minWidth: 160 } },
                    react_1.default.createElement(Dots_1.default, null))),
                !isLoading && (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, style: { maxWidth: 160, minWidth: 160 } },
                    react_1.default.createElement(IconButton_1.default, { noOpacity: true, disabled: !hasPrev, icon: react_1.default.createElement(ChevronLeftIcon_1.default, { color: !hasPrev ? lib_palette_1.default.positive : lib_palette_1.default.White }), onClick: handleClickPrev }),
                    react_1.default.createElement(Pane_1.default, null,
                        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { InputProps: {
                                startAdornment: (react_1.default.createElement(Text_1.default, { noWrap: true, style: { margin: '0 3px 4px 0', color: 'white' } }, lib_i18n_1.default.t('page'))),
                                endAdornment: (react_1.default.createElement(Text_1.default, { noWrap: true, style: { margin: '0 0 4px 0', color: 'white' } }, lib_i18n_1.default.t('of-y', {
                                    y: numOfPages,
                                }))),
                            }, inputProps: {
                                min: 1,
                                max: numOfPages,
                                className: 'nospinner',
                                style: {
                                    maxWidth: 20,
                                    zIndex: 1,
                                    color: 'white',
                                },
                            }, type: "number", noBorder: true, value: reportPage + 1, onBlur: handleChangePage })),
                    react_1.default.createElement(IconButton_1.default, { noOpacity: true, disabled: !hasNext, icon: react_1.default.createElement(ChevronRightIcon_1.default, { color: !hasNext ? lib_palette_1.default.positive : lib_palette_1.default.White }), onClick: handleClickNext })))),
            react_1.default.createElement(Pane_1.default, { onClick: handleClickExpand, center: true, classes: { root: myCss.expander } }, expanded ? react_1.default.createElement(CollapseMoreIcon_1.default, { size: 12 }) : react_1.default.createElement(ExpandMoreIcon_1.default, { size: 12 }))));
    }, [
        bigGroupBy,
        loading,
        associatedFilters,
        totalCount,
        dt,
        reportPage,
        numOfPages,
        myCss,
        handleClickPrev,
        handleChangePage,
        handleClickNext,
        handleClickExpand,
        expanded,
    ]);
};
